import { AgentConversationListEntryDto } from './agent-api.model';

export type AgentConversationGroupKey = 'today' | 'yesterday' | 'older';

/** Conversations of one section of the history, newest first. */
export interface AgentConversationGroup {
  key: AgentConversationGroupKey;
  items: AgentConversationListEntryDto[];
}

const GROUP_ORDER: readonly AgentConversationGroupKey[] = ['today', 'yesterday', 'older'];

/** Last activity of a conversation, as shown in the history. */
export const conversationDate = (conversation: AgentConversationListEntryDto): Date =>
  new Date(conversation.editedAt ?? conversation.createdAt);

const startOfDay = (date: Date): number => new Date(date.getFullYear(), date.getMonth(), date.getDate()).getTime();

/** Section of a date relative to `now`, in local time. */
export const conversationGroupKey = (date: Date, now: Date): AgentConversationGroupKey => {
  const today = startOfDay(now);
  const day = startOfDay(date);
  if (day >= today) return 'today';
  return day >= startOfDay(new Date(today - 1)) ? 'yesterday' : 'older';
};

/** Splits the history into Today / Yesterday / Older by last activity; empty sections are left out. */
export const groupConversations = (
  conversations: readonly AgentConversationListEntryDto[],
  now: Date
): AgentConversationGroup[] => {
  const sorted = [...conversations].sort((a, b) => conversationDate(b).getTime() - conversationDate(a).getTime());
  return GROUP_ORDER.map((key) => ({
    key,
    items: sorted.filter((conversation) => conversationGroupKey(conversationDate(conversation), now) === key)
  })).filter(({ items }) => items.length > 0);
};
